// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__0OhZR","link":"contact_link__ObBPn","line":"contact_line__RP5Ga","mail":"contact_mail__otcsP"};